import { Controller } from "react-hook-form";
import {
  Box,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import AccessTime from "@mui/icons-material/AccessTime";
import { getReactHookFormNestedError } from "../../utils/errors";
import { INPUT_COLOR_BORDER } from "../../utils/colors";
import { BORDER_RADIUS } from "../../utils/constants";

const TimeField = ({
  control,
  errors = {},
  name = "",
  disabled = false,
  rules = {},
  fullWidth = true,
  id = "",
}) => {
  const error = getReactHookFormNestedError(errors, name);

  const commonSX = {
    flex: 1,
    "& fieldset": { border: "none" },
    "& input": { textAlign: "center" },
  };

  return (
    <Box sx={{ width: fullWidth ? "100%" : "auto" }}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field }) => (
          <Box
            sx={(theme) => ({
              display: "flex",
              borderRadius: BORDER_RADIUS,
              overflow: "hidden",
              width: "100%",
              border: `1px solid ${
                error ? theme.palette.error.main : INPUT_COLOR_BORDER
              }`,
              boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
              backgroundColor: "fields.background",
            })}
          >
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                minWidth: 0,
              }}
            >
              <TextField
                id={id || name}
                name={name}
                type="time"
                value={field.value || ""}
                onChange={(event) => field.onChange(event.target.value)}
                disabled={disabled}
                size="small"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccessTime fontSize="medium" />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  step: 300,
                }}
                sx={{
                  ...commonSX,
                  "& .MuiInputBase-root": {
                    py: 2,
                    pl: 1,
                  },
                  "& input": {
                    pr: 0,
                    textAlign: "center",
                    cursor: "pointer",
                  },
                  "& input[type='time']::-webkit-calendar-picker-indicator": {
                    display: "none",
                  },
                  "& input[type='time']::-webkit-inner-spin-button": {
                    display: "none",
                  },
                }}
              />
            </Box>
          </Box>
        )}
      />
      {error?.message && (
        <Typography variant="caption" color="error">
          {error.message}
        </Typography>
      )}
    </Box>
  );
};

export default TimeField;
